import React, { useEffect, useRef } from "react";
import {
  Container,
  Wrapper,
  Title,
  Paragraph,
  Button,
  Image,
} from "../../library/components";
import Servicio1 from "../../assets/servicio1.jpg";
import Servicio2 from "../../assets/servicio2.jpeg";
import Servicio3 from "../../assets/servicio3.jpg";
import Slider from "react-slick";
import styled from "styled-components";

const FullWrapper = styled.div`
  padding: 4rem 0;
  max-width: 90%;
  margin: auto;
`;

const Services = () => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <FullWrapper>
      <Slider {...settings}>
        <div className="m-flex">
          <Container
            style={{ margin: 0 }}
            align="flex-start"
            background="#C8F8FF"
          >
            <Title size="22px" color="#0189D1">
              Nuestros Servicios
            </Title>
            <Title size="48px" color="2B292D">
              SOLUCIONES DE GESTION
            </Title>
            <Paragraph>
              Servicios de reducción y control de emisiones.
              <br />
              <br />
              Servicios de optimización de procesos.
              <br />
              <br />
              Servicios de gestión circular de residuos.
              <br />
              <br />
            </Paragraph>
          </Container>
          <Container>
            <Image width="100%" height="auto" src={Servicio1} />
          </Container>
        </div>
        <div className="m-flex">
          <Container
            style={{ margin: 0 }}
            align="flex-start"
            background="#C8F8FF"
          >
            <Title size="22px" color="#0189D1">
              Nuestros Servicios
            </Title>
            <Title size="48px" color="2B292D">
              SOLUCIONES PARA DETECCION AMPLIADA DE PERDIDAS Y LDAR
            </Title>
            <Paragraph>
              Servicios de detección y reparación de pérdidas{" "}
              <strong>LDAR</strong> <br />
              <br />
              Monitoreo satelital de pérdidas y emisiones <br />
              <br />
              Detección y control de pérdidas en áreas de yacimientos
              <br />
              <br />
              Monitoreo 24x7 de pérdidas y emisiones en instalaciones y
              operaciones de pozos.
              <br />
              <br />
            </Paragraph>
          </Container>
          <Container>
            <Image width="100%" height="auto" src={Servicio2} />
          </Container>
        </div>
        <div className="m-flex">
          <Container
            style={{ margin: 0 }}
            align="flex-start"
            background="#C8F8FF"
          >
            <Title size="22px" color="#0189D1">
              Nuestros Servicios
            </Title>
            <Title size="48px" color="2B292D">
              Otros Servicios
            </Title>
            <Paragraph>
              <strong>SOLUCIONES PARA AGUA DE FRACTURA.</strong>
              <br />
              <br />
              <strong>SOLUCIONES PARA SISTEMAS DE FLARE. </strong>
              <br />
              <br />
              <strong>SOLUCIONES PARA RECUPERO DE VAPORES (VRU).</strong>
              <br />
              <br />
              <strong>SOLUCIONES PARA TORRES TEG.</strong>
              <br />
              <br />
              <strong>SOLUCIONES PARA RECUPERO DE SUBPRODUCTOS</strong>
              <br />
              <br />
              <strong>
                SOLUCIONES PARA LA INDUSTRIA DE GENERACION SOLUCIONES
                <br /> PARA LA TRANSMISION ELECTRICA.
              </strong>
              <br />
              Inspección aérea de redes de energía eléctrica
            </Paragraph>
          </Container>
          <Container>
            <Image width="100%" height="auto" src={Servicio3} />
          </Container>
        </div>
      </Slider>
    </FullWrapper>
  );
};

export default Services;
